import { useRequestSingleBranchQuery } from '@/features/branches/services/Branches.service';

interface BranchTimeZone {
  /** Undefined until the branch has loaded, and when it cannot be loaded. */
  timeZoneId?: string;
  isError: boolean;
}

/**
 * Time zone of the trip's branch. Driving-log entries are shown and entered in branch time, the
 * same as the trip's own start and end times. There is deliberately no fallback to the browser's
 * zone: an entry saved in the wrong zone would be stored at the wrong instant.
 */
export const useBranchTimeZoneId = (branchId?: number): BranchTimeZone => {
  const { data: branch, isError } = useRequestSingleBranchQuery(String(branchId), {
    skip: !branchId,
  });

  return {
    timeZoneId: branch?.timeZoneId,
    isError: isError || (!!branch && !branch.timeZoneId),
  };
};
